// extracted by mini-css-extract-plugin
export default {"root":"o_Y0K","flames":"_1sCn6","flame":"_2hofH"};